/** Insert or replace an item in a list keyed by `id`. New items go to the front. */
export function upsertById<T extends { id: string }>(
  items: T[],
  next: T,
): T[] {
  const index = items.findIndex((item) => item.id === next.id)
  if (index === -1) return [next, ...items]
  return items.map((item, i) => (i === index ? next : item))
}
